/**
 * Shared stun blink language (boss break-stun / ally AoE stun).
 * Phaser-free pure helpers — view applies alphas to sprites.
 */

export const STUN_BLINK_TINT = 0xc4c4ce;

/** Matches legacy: `Math.floor(time * 10) % 2`. */
export const STUN_BLINK_RATE = 10;

/** Distinct from elite toughness-break glyph. */
export const ALLY_STUN_ICON_GLYPH = "✦";

export type StunBlinkAlphas = {
  body: number;
  rig: number;
};

const BOSS_ALPHAS = {
  on: { body: 0.95, rig: 0.9 },
  off: { body: 0.28, rig: 0.22 },
} as const;

const ALLY_ALPHAS = {
  on: { body: 0.92, rig: 0.88 },
  off: { body: 0.42, rig: 0.38 },
} as const;

/** Hard on/off phase for stun blink. */
export function stunBlinkOn(time: number, rate = STUN_BLINK_RATE): boolean {
  return Math.floor(time * rate) % 2 === 0;
}

export function stunBlinkAlphas(
  blinkOn: boolean,
  kind: "boss" | "ally",
): StunBlinkAlphas {
  const table = kind === "boss" ? BOSS_ALPHAS : ALLY_ALPHAS;
  return blinkOn ? { ...table.on } : { ...table.off };
}

/** Left edge of HP bar, just under the lowest chrome row (HP or skill CD). */
export function allyStunIconLocalPos(opts: {
  barW: number;
  hpY: number;
  barH: number;
  skillY: number | null;
  skillH: number;
}): { x: number; y: number } {
  const underHp = opts.hpY + opts.barH * 0.5 + 6;
  const underSkill =
    opts.skillY != null ? opts.skillY + opts.skillH * 0.5 + 5 : underHp;
  return {
    x: -opts.barW / 2,
    y: opts.skillY != null ? underSkill : underHp,
  };
}
